function initMultiContactUi() {
  const phonesSection = document.querySelector('#phones')
  if (!phonesSection) return false

  const content = phonesSection.querySelector('.sub-section-content')
  if (!content) return false

  const personMatch = window.location.pathname.match(/\/edit-person\/(\d+)/)
  const companyMatch = window.location.pathname.match(/\/edit-company\/(\d+)/)
  const contactId = (personMatch ? personMatch[1] : null) || (companyMatch ? companyMatch[1] : null)
  if (!contactId) return false

  if (content.querySelector('[data-multi-contact-ui01="add-button-row"]')) return true

  const titleEl = phonesSection.querySelector('.sub-section-header .sub-section-title')
  let loadingSpinner = null
  if (titleEl) {
    loadingSpinner = document.createElement('span')
    loadingSpinner.className = 'multi-contact-spinner hidden'
    loadingSpinner.setAttribute('data-multi-contact-ui01', 'spinner')
    loadingSpinner.setAttribute('aria-hidden', 'true')
    titleEl.appendChild(loadingSpinner)
  }

  const addButtonRow = document.createElement('div')
  addButtonRow.className = 'sub-section-content-row row mt-4'
  addButtonRow.setAttribute('data-multi-contact-ui01', 'add-button-row')
  addButtonRow.innerHTML = `
    <div class="sub-section-content-column">
      <button type="button" class="ant-btn ant-btn-default Button AdditionalEntityButton multi-contact-add-btn w-full" data-multi-contact-ui01="add-btn">
        <span role="img" class="anticon">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 7H9V0H7V7H0V9H7V16H9V9H16V7Z" fill="currentColor"></path>
          </svg>
        </span>
        <div class="label">Kontaktmöglichkeit hinzufügen</div>
      </button>
    </div>
  `
  const sendSeparatelyRow = document.createElement('div')
  sendSeparatelyRow.className = 'sub-section-content-row'
  sendSeparatelyRow.setAttribute('data-multi-contact-ui01', 'send-separately-row')
  sendSeparatelyRow.innerHTML = `
    <div class="sub-section-content-column">
      <label class="ant-checkbox-wrapper ant-checkbox-wrapper-in-form-item ant-checkbox-group-item multi-contact-checkbox-row" for="multi-contact-send-separately" data-multi-contact-ui01="send-separately-label">
        <span class="ant-checkbox" data-multi-contact-ui01="send-separately-box">
          <input
            id="multi-contact-send-separately"
            type="checkbox"
            class="ant-checkbox-input"
            data-multi-contact-ui01="send-separately-input"
          />
          <span class="ant-checkbox-inner"></span>
        </span>
        <span>Einzeln anschreiben</span>
      </label>
    </div>
  `
  const style = document.createElement('style')
  style.textContent = `
      .multi-contact-spinner {
        display: inline-block;
        vertical-align: middle;
        border: 4px solid rgba(0, 0, 0, 0.1);
        width: 22px;
        height: 22px;
        border-radius: 50%;
        border-left-color: black;
        margin-left: 8px;
        animation: multi-contact-spin 1s ease infinite;
      }
      .multi-contact-spinner.hidden {
        display: none !important;
      }
      @keyframes multi-contact-spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .multi-contact-combined-input {
        display: flex;
        align-items: stretch;
        border: .2rem solid #eee;
        border-radius: .6rem;
        background: rgba(255, 255, 255, 0.85);
        min-height: 40px;
        overflow: hidden;
      }
      .multi-contact-combined-input:hover .multi-contact-type-in-input {
        border-color: #111112;
      }
      .multi-contact-combined-input:hover {
        border-color: #111112;
      }
      .multi-contact-type-in-input {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 0 8px;
        margin-left:1rem;
        border-right: 1px solid rgba(17, 17, 18, 0.12);
        background: transparent;
      }
      .multi-contact-type-in-input .multi-contact-type-icon {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        color: #727279;
      }
      .multi-contact-type-in-input select {
        border: none;
        background: none;
        font: 500 14px/24px Inter, sans-serif;
        color: #1B1B1D;
        cursor: pointer;
        padding: 0 4px 0 0;
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3 4.5L6 7.5L9 4.5' stroke='%23727279' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 0 center;
        padding-right: 10px;
      }
      .multi-contact-type-in-input select:focus {
        outline: none;
      }
      .multi-contact-value-in-input {
        flex: 1;
        min-width: 0;
      }
      .multi-contact-value-in-input input {
        width: 100%;
        height: 100%;
        min-height: 38px;
        border: none;
        padding: 0 12px;
        font: 500 14px/24px Inter, sans-serif;
        color: #1B1B1D;
        background: transparent;
      }
      .multi-contact-value-in-input input::placeholder {
        color: #B6B6B9;
      }
      .multi-contact-value-in-input input:focus {
        outline: none;
      }
      .multi-contact-checkbox-row {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        font: 500 18px/28px Inter, sans-serif;
        color: #1B1B1D;
        cursor: pointer;
        width: fit-content;
      }
      .multi-contact-checkbox-row .ant-checkbox {
        top: 0;
      }
      .multi-contact-checkbox-row .ant-checkbox-input {
        cursor: pointer;
      }
      .multi-contact-delete-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        cursor: pointer;
        color: #727279;
        padding: 0 12px;
        min-width: 40px;
        min-height: 40px;
        align-self: stretch;
        border: 1px solid rgba(17, 17, 18, 0.12);
        border-radius: .6rem;
        background: rgba(255, 255, 255, 0.6);
        transition: color .2s, border-color .2s, background .2s;
      }
      .multi-contact-delete-btn:hover {
        color: #ff4d4f;
        border-color: rgba(255, 77, 79, 0.4);
        background: rgba(255, 77, 79, 0.06);
      }
      .multi-contact-create-row .multi-contact-value-control {
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        align-items: stretch;
        gap: 8px;
      }
      .multi-contact-create-row .multi-contact-value-control .ant-form-item-control-input {
        flex: 1 1 auto;
        min-width: 0;
      }
      .contact-item {
        border-left: 2px solid rgb(220, 220, 220) ; 
        padding-left: 1rem;
      }
      .multi-contact-value-input.ant-input-status-error,
      .multi-contact-title-input.ant-input-status-error {
        border-color: #ff4d4f;
      }
      .multi-contact-value-error {
        color: #ff4d4f;
        font-size: 12px;
        margin-top: 4px;
      }
      .multi-contact-create-row.multi-contact-row-enter {
        animation: multi-contact-row-enter 0.25s ease-out forwards;
      }
      @keyframes multi-contact-row-enter {
        from {
          opacity: 0;
          transform: translateY(-8px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
  `
  document.head.appendChild(style)
  content.appendChild(addButtonRow)
  content.appendChild(sendSeparatelyRow)

  function setSectionLoading(loading) {
    if (!loadingSpinner) return
    if (loading) {
      loadingSpinner.classList.remove('hidden')
      const rows = content.querySelectorAll('[data-multi-contact-ui01="create-row"]')
      rows.forEach((row) => {
        row.style.pointerEvents = 'none'
        row.style.opacity = '0.6'
        const inputs = row.querySelectorAll('input, select')
        inputs.forEach((el) => { el.disabled = true })
        const deleteBtn = row.querySelector('[data-multi-contact-ui01="delete-btn"]')
        if (deleteBtn) deleteBtn.disabled = true
      })
        const sendSeparatelyInput = content.querySelector('[data-multi-contact-ui01="send-separately-input"]')
        if (sendSeparatelyInput) sendSeparatelyInput.disabled = true
    } else {
      loadingSpinner.classList.add('hidden')
      const rows = content.querySelectorAll('[data-multi-contact-ui01="create-row"]')
      rows.forEach((row) => {
        row.style.pointerEvents = ''
        row.style.opacity = ''
        const inputs = row.querySelectorAll('input, select')
        inputs.forEach((el) => { el.disabled = false })
        const deleteBtn = row.querySelector('[data-multi-contact-ui01="delete-btn"]')
        if (deleteBtn) deleteBtn.disabled = false
      })
        const sendSeparatelyInput = content.querySelector('[data-multi-contact-ui01="send-separately-input"]')
        if (sendSeparatelyInput) sendSeparatelyInput.disabled = false
    }
  }

  function createNewContactRow(initialData) {
    const row = document.createElement('div')
    row.className = 'sub-section-content-row multi-contact-create-row'
    row.setAttribute('data-multi-contact-ui01', 'create-row')
    if (initialData?.id != null) row.setAttribute('data-item-id', String(initialData.id))

    const typeOptions = [
      { value: 'email', label: 'E-Mail' },
      { value: 'tel', label: 'Telefon' },
    ]

    row.innerHTML = `
      <div class="sub-section-content-column " style="min-width: 25rem; display: flex; flex-direction: row; gap: 12px;">
        <div class="TextInput contact-item " style="flex: 1;">
          <div class="ant-row ant-form-item" style="row-gap: 0px;">
            <div class="ant-col ant-form-item-label">
              <label class="" title=""><span><span>Kontaktname</span></span></label>
            </div>
            <div class="ant-col ant-form-item-control">
              <div class="ant-form-item-control-input">
                <div class="ant-form-item-control-input-content">
                  <input class="ant-input Input multi-contact-title-input" type="text" placeholder="z. B. Ehepartner" value="" data-multi-contact-ui01="title-input" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="TextInput" style="flex: 1; margin-left: 2rem;">
          <div class="ant-row ant-form-item" style="row-gap: 0px;">
            <div class="ant-col ant-form-item-label">
              <label class="" title=""><span><span>Kontakt</span></span></label>
            </div>
            <div class="ant-col ant-form-item-control multi-contact-value-control">
              <div class="ant-form-item-control-input">
                <div class="ant-form-item-control-input-content multi-contact-combined-input">
                  <div class="multi-contact-type-in-input">
                    <span class="multi-contact-type-icon" data-multi-contact-ui01="type-icon" aria-hidden="true">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 3h12v1.5l-6 4.5-6-4.5V3zm0 3.5l6 4.5 6-4.5V13H2V6.5z" fill="currentColor"/>
                      </svg>
                    </span>
                    <select class="multi-contact-type-select" data-multi-contact-ui01="type-select" title="Typ">
                      ${typeOptions.map((o) => `<option value="${o.value}">${o.label}</option>`).join('')}
                    </select>
                  </div>
                  <div class="multi-contact-value-in-input">
                    <input class="multi-contact-value-input" type="email" placeholder="Bitte ausfüllen..." value="" data-multi-contact-ui01="value-input" />
                  </div>
                </div>
              </div>
              <button type="button" class="multi-contact-delete-btn" data-multi-contact-ui01="delete-btn" title="Entfernen" aria-label="Kontaktzeile entfernen">
                <svg class="multi-contact-delete-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2"/>
                  <line x1="10" y1="11" x2="10" y2="17"/>
                  <line x1="14" y1="11" x2="14" y2="17"/>
                </svg>
              </button>
            </div>
            <div class="ant-form-item-explain ant-form-item-explain-connected" data-multi-contact-ui01="value-error-wrap" style="display: none;">
              <div class="multi-contact-value-error" data-multi-contact-ui01="value-error" role="alert"></div>
            </div>
          </div>
        </div>
      </div>
    `

    const typeSelect = row.querySelector('[data-multi-contact-ui01="type-select"]')
    const typeIcon = row.querySelector('[data-multi-contact-ui01="type-icon"]')
    const valueInput = row.querySelector('[data-multi-contact-ui01="value-input"]')
    const deleteBtn = row.querySelector('[data-multi-contact-ui01="delete-btn"]')

    const typeIconSvgs = {
      email: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 3h12v1.5l-6 4.5-6-4.5V3zm0 3.5l6 4.5 6-4.5V13H2V6.5z" fill="currentColor"/></svg>',
      tel: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 2h2l1.5 1.5c.4.4.2 1-.2 1.3L5.5 6.2c.5.9 1.2 1.6 2.1 2.1l1.4-1.3c.3-.4.9-.6 1.3-.2L14 10.5 15.5 12v2c0 .83-.67 1.5-1.5 1.5-7.18 0-13-5.82-13-13 0-.83.67-1.5 1.5-1.5z" fill="currentColor"/></svg>'
    }

    function setInputType(type) {
      const isEmail = type === 'email'
      valueInput.type = isEmail ? 'email' : 'tel'
      valueInput.placeholder = 'Bitte ausfüllen...'
      if (typeIcon && typeIconSvgs[type]) typeIcon.innerHTML = typeIconSvgs[type]
    }

    typeSelect.addEventListener('change', function () {
      setInputType(this.value)
    })

    async function handleDelete() {
      const itemId = row.getAttribute('data-item-id')
      const confirmed = window.confirm(
        'Kontaktmöglichkeit wirklich entfernen?'
      )
      if (!confirmed) return
      if (itemId) {
        const authData = JSON.parse(localStorage.getItem('auth') || '{}')
        const token = authData.token
        if (!token) return
        row.style.display = 'none'
        try {
          const res = await fetch(
            `${baseApiUrl}/api/impowerX/contacts/contact-options/${itemId}`,
            { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } }
          )
          if (!res.ok) {
            console.error('Delete contact option failed:', res.status)
            row.style.display = ''
            return
          }
          // Same as Speichern: mark person view stale so injects remount on navigate-back
          if (personMatch) {
            window.__impowerxPersonViewNeedsRefresh = contactId
          }
        } catch (e) {
          console.error('Delete contact option error:', e)
          row.style.display = ''
          return
        }
      }
      row.remove()
      if (!content.querySelector('[data-multi-contact-ui01="create-row"]')) {
        addButtonLabel.textContent = 'Weiteren Kontaktmöglichkeit hinzufügen'
      }
    }
    deleteBtn.addEventListener('click', handleDelete)

    function clearRowError() {
      const titleInput = row.querySelector('[data-multi-contact-ui01="title-input"]')
      const wrap = row.querySelector('[data-multi-contact-ui01="value-error-wrap"]')
      const errEl = row.querySelector('[data-multi-contact-ui01="value-error"]')
      if (wrap) wrap.style.display = 'none'
      if (errEl) errEl.textContent = ''
      valueInput.classList.remove('ant-input-status-error')
      if (titleInput) titleInput.classList.remove('ant-input-status-error')
    }
    const titleInputForClear = row.querySelector('[data-multi-contact-ui01="title-input"]')
    valueInput.addEventListener('input', clearRowError)
    valueInput.addEventListener('change', clearRowError)
    typeSelect.addEventListener('change', clearRowError)
    if (titleInputForClear) {
      titleInputForClear.addEventListener('input', clearRowError)
      titleInputForClear.addEventListener('change', clearRowError)
    }

    if (initialData) {
      const titleInput = row.querySelector('[data-multi-contact-ui01="title-input"]')
      if (titleInput) titleInput.value = initialData.title ?? ''
      typeSelect.value = initialData.type === 'tel' ? 'tel' : 'email'
      valueInput.value = initialData.value ?? ''
    }
    setInputType(typeSelect.value)
    return row
  }

  const addBtn = addButtonRow.querySelector('[data-multi-contact-ui01="add-btn"]')
  const addButtonLabel = addButtonRow.querySelector('.label')
  const sendSeparatelyLabel = sendSeparatelyRow.querySelector('[data-multi-contact-ui01="send-separately-label"]')
  const sendSeparatelyBox = sendSeparatelyRow.querySelector('[data-multi-contact-ui01="send-separately-box"]')
  const sendSeparatelyInput = sendSeparatelyRow.querySelector('[data-multi-contact-ui01="send-separately-input"]')

  function syncSendSeparatelyCheckboxState() {
    if (!sendSeparatelyInput || !sendSeparatelyLabel || !sendSeparatelyBox) return
    sendSeparatelyLabel.classList.toggle('ant-checkbox-wrapper-checked', sendSeparatelyInput.checked)
    sendSeparatelyBox.classList.toggle('ant-checkbox-checked', sendSeparatelyInput.checked)
  }

  sendSeparatelyInput?.addEventListener('change', syncSendSeparatelyCheckboxState)

  function insertContactRowAnimated(row) {
    content.insertBefore(row, addButtonRow)
    row.classList.add('multi-contact-row-enter')
    row.addEventListener('animationend', () => row.classList.remove('multi-contact-row-enter'), { once: true })
  }

  addBtn.addEventListener('click', function () {
    insertContactRowAnimated(createNewContactRow())
  })
  // set button is being used as loading indicator during loading contact options
  //this way we gurantee that the button is not clickable during loading 
  //And also we avoid the flickering of adding new row when loading is finished
  function setAddButtonLoading(loading, loadingMessage) {
    addBtn.disabled = loading
    addBtn.classList.toggle('ant-btn-loading', loading)
    setSectionLoading(loading)
    if (loading) {
      addButtonLabel.textContent = loadingMessage || 'Kontaktmöglichkeiten werden geladen…'
    } else {
      addButtonLabel.textContent = content.querySelector('[data-multi-contact-ui01="create-row"]')
        ? 'Weiteren Kontaktmöglichkeit hinzufügen'
        : 'Kontaktmöglichkeit hinzufügen'
    }
  }

  async function loadContactOptions() {
    const authData = JSON.parse(localStorage.getItem('auth') || '{}')
    const token = authData.token
    if (!token) return
    setAddButtonLoading(true)
    try {
      const res = await fetch(
        `${baseApiUrl}/api/impowerX/contacts/contact-options?contactId=${contactId}`,
        { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
      )
      if (!res.ok) return
      const data = await res.json()
      const items = data.items || []
      items.forEach((item) => {
        insertContactRowAnimated(createNewContactRow(item))
      })
    } catch (e) {
      console.error('Load contact options error:', e)
    } finally {
      setAddButtonLoading(false)
    }
  }

  async function loadSendSeparatelyPreference() {
    const authData = JSON.parse(localStorage.getItem('auth') || '{}')
    const token = authData.token
    if (!token || !sendSeparatelyInput) return

    try {
      const res = await fetch(
        `${baseApiUrl}/api/impowerX/contacts/send-separately?contactId=${contactId}`,
        { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
      )
      if (!res.ok) return
      const data = await res.json()
      sendSeparatelyInput.checked = data.sendSeparately === true
      syncSendSeparatelyCheckboxState()
    } catch (e) {
      console.error('Load send separately preference error:', e)
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim())
  }
  function isValidPhone(value) {
    const trimmed = (value || '').trim()
    const digitCount = (trimmed.match(/\d/g) || []).length
    return /^[\d+\s\-()]+$/.test(trimmed) && digitCount >= 5
  }

  async function saveContactOptions(e) {
    const personMatch = window.location.pathname.match(/\/edit-person\/(\d+)/)
    const companyMatch = window.location.pathname.match(/\/edit-company\/(\d+)/)
    const currentContactId = (personMatch ? personMatch[1] : null) || (companyMatch ? companyMatch[1] : null)
    if (!currentContactId) return
    const authData = JSON.parse(localStorage.getItem('auth') || '{}')
    const token = authData.token
    if (!token) return
    const rows = content.querySelectorAll('[data-multi-contact-ui01="create-row"]')
    let hasError = false
    rows.forEach((row) => {
      const titleInput = row.querySelector('[data-multi-contact-ui01="title-input"]')
      const valueInput = row.querySelector('[data-multi-contact-ui01="value-input"]')
      const typeSelect = row.querySelector('[data-multi-contact-ui01="type-select"]')
      const wrap = row.querySelector('[data-multi-contact-ui01="value-error-wrap"]')
      const errEl = row.querySelector('[data-multi-contact-ui01="value-error"]')
      const title = titleInput?.value?.trim() ?? ''
      const value = valueInput?.value?.trim() ?? ''
      const type = typeSelect?.value === 'tel' ? 'tel' : 'email'
      if (wrap) wrap.style.display = 'none'
      if (errEl) errEl.textContent = ''
      valueInput?.classList.remove('ant-input-status-error')
      titleInput?.classList.remove('ant-input-status-error')
      if (!value) return
      const messages = []
      if (!title) {
        messages.push('Kontaktname ist Pflicht')
        titleInput?.classList.add('ant-input-status-error')
      }
      if (type === 'email' && !isValidEmail(value)) {
        messages.push('Ungültige E-Mail-Adresse')
        valueInput?.classList.add('ant-input-status-error')
      }
      if (type === 'tel' && !isValidPhone(value)) {
        messages.push('Ungültige Telefonnummer (mind. 5 Ziffern, nur + - ( ) und Ziffern)')
        valueInput?.classList.add('ant-input-status-error')
      }
      if (messages.length) {
        hasError = true
        if (wrap) wrap.style.display = 'block'
        if (errEl) errEl.textContent = messages.join(' ')
      }
    })
    if (hasError) {
      alert('Bitte korrigieren Sie die Fehler in den Kontaktzeilen')
      e.stopPropagation()
      return
    }
    setAddButtonLoading(true, 'Speichern…')
    const sendSeparately = Boolean(sendSeparatelyInput?.checked)
    const items = []
    rows.forEach((row) => {
      const titleInput = row.querySelector('[data-multi-contact-ui01="title-input"]')
      const typeSelect = row.querySelector('[data-multi-contact-ui01="type-select"]')
      const valueInput = row.querySelector('[data-multi-contact-ui01="value-input"]')
      const id = row.getAttribute('data-item-id')
      const title = titleInput?.value?.trim() ?? ''
      const type = typeSelect?.value === 'tel' ? 'tel' : 'email'
      const value = valueInput?.value?.trim() ?? ''
      items.push({
        ...(id ? { id: parseInt(id, 10) } : {}),
        title,
        type,
        value,
      })
    })
    try {
      const [contactOptionsRes, sendSeparatelyRes] = await Promise.all([
        fetch(`${baseApiUrl}/api/impowerX/contacts/contact-options`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({ contactId: currentContactId, items }),
        }),
        fetch(`${baseApiUrl}/api/impowerX/contacts/send-separately`, {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({ contactId: currentContactId, sendSeparately }),
        })
      ])
      if (!contactOptionsRes.ok) {
        console.error('Save contact options failed:', contactOptionsRes.status)
        return
      }
      if (!sendSeparatelyRes.ok) {
        console.error('Save send separately preference failed:', sendSeparatelyRes.status)
        return
      }
      const data = await contactOptionsRes.json()
      const savedItems = data.items || []
      rows.forEach((r) => r.remove())
      savedItems.forEach((item) => {
        insertContactRowAnimated(createNewContactRow(item))
      })
    } catch (e) {
      console.error('Save contact options error:', e)
    } finally {
      setAddButtonLoading(false)
    }
  }

  setTimeout(() => {
    loadSendSeparatelyPreference()
    loadContactOptions()
  }, 500)

  const saveBtn = document.querySelector('button.ant-btn-primary.save')
  const saveSectionBtn = document.querySelector('.FormSection#ContactData .Button.section-submit')
  if (saveBtn) saveBtn.addEventListener('click', saveContactOptions)
  if (saveSectionBtn) saveSectionBtn.addEventListener('click',  saveContactOptions)

  return true
}
